import type { Permission } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import type { AuthUserData } from '../ducks/auth/types';

const checkPermission = (
  permissions: string[] = [],
  permission: Permission,
  userData: AuthUserData,
) => {
  const isAdmin = userData.is_admin;
  return permissions.indexOf(permission) >= 0 || isAdmin;
};
export default checkPermission;
